module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f3.bb0ea8b9.webp";